var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9819 6.40463C11.9819 3.22307 9.18662 0.681874 5.88205 1.03238C3.37908 1.29751 1.35112 3.26352 1.04282 5.72158C0.864684 7.14385 1.25292 8.4695 2.01112 9.52103L5.71077 14.6057C6.09444 15.1314 6.8869 15.1314 7.27057 14.6057L10.9702 9.52103C11.6051 8.64026 11.9819 7.56626 11.9819 6.40463Z",
    stroke: "#56565A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49199 8.41554C7.75326 8.41554 8.77573 7.40958 8.77573 6.16868C8.77573 4.92777 7.75326 3.92181 6.49199 3.92181C5.23072 3.92181 4.20825 4.92777 4.20825 6.16868C4.20825 7.40958 5.23072 8.41554 6.49199 8.41554Z",
    stroke: "#56565A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.db02f6dc8e9d05e7f00e3f9009816669.svg";
export { ForwardRef as ReactComponent };